export const model = {
  name: '',
  parent_id: null
};